import React, { useEffect } from 'react';
import './App.css';
import AppRoot from "./app/AppRoot";
import Header from "./app/blocks/menu/Header";
import config from './config';

function App() {

    useEffect(() => {
        document.documentElement.setAttribute('data-variant', config.theme);
        document.title = config.title;
    }, []);

    return (
        <>
            <Header />
            <div className="layout">
                <AppRoot />
            </div>
        </>
    );
}

export default App;
